/** basic.siteManage */
export default {
    search_site: "Поиск по названию объекта",
    search_siteAddr: "Поиск по адресу объекта",
    addBtn: "Добавить",
    site_collectTips: "Добавить этот объект в избранное?",
    site_drawerTitle: "Детали объекта",
    site_news: "Информация об объекте",
    site_contactPerson: "Контактное лицо:",
    site_contactPersonPhone: "Телефон контакта:",
    site_log: "Долгота:",
    site_lng: "Широта:",
    site_contactPersonName: "Имя контакта:",
    site_contactPersonNamePla: "Введите имя контакта",
    site_contactPersonNum: "Контактный телефон",
    site_contactPersonNumPla: "Введите контактный телефон",
    site_imgNews: "Информация об изображениях",
    site_contactPersonPla: "Введите контактное лицо",
    site_contactPersonPhonePla: "Введите телефон контакта",
    site_siteAddr: "Адрес объекта",
    site_logPla: "Введите долготу",
    site_lngPla: "Введите широту",
    site_ruleSiteName: "Название объекта не может быть пустым",
    site_ruleSiteAddr: "Адрес объекта не может быть пустым",
    site_ruleContactName: "Имя контакта не может быть пустым",
    site_rulePhone: "Телефон контакта не может быть пустым",
    site_rulePhoneTwo: "Не удалось добавить данные! Проверьте формат телефона!",
    site_modelID: "ID модели",
    site_modelNnme: "Название модели",
    site_modelCreateTime: "Время создания",
    site_modelNamePla: "Введите название модели",
    site_collectSucc: "Объект добавлен в избранное!",
    site_collectLose: "Не удалось добавить объект в избранное!",
    site_editSucc: "Точка успешно изменена!",
    site_editLose: "Не удалось изменить точку!",
    site_cancelAddSite: "Добавление объекта отменено!",
    site_delete_tips:
        "После удаления объекта будут удалены точки и этажи, а связанные устройства станут непривязанными. Удалить объект?",
}

